import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})

export class EmojiService {

  constructor(
    @Inject(PLATFORM_ID) private platform: Object,
  ) { }

  toUni(str) {
    if (str.length < 4) {
      return str.codePointAt(0).toString(16);
    }
    return str.codePointAt(0).toString(16) + '-' + str.codePointAt(2).toString(16);
  }

  getEmojiWithText(emoji, text) {
    if (!isPlatformBrowser(this.platform)) {
      return;
    }
    if (!emoji || emoji === '') {
      return text;
    }
    const unicodeEmoji = this.toUni(emoji);
    const fromCodePoint = twemoji.convert.fromCodePoint(unicodeEmoji);
    const fullText = fromCodePoint + ' ' + text;
    const emoji1 = twemoji.parse(fullText, {
      folder: 'svg',
      ext: '.svg'
    });
    return emoji1;
  }

  getEmoji(emojiCode) {
    if (!isPlatformBrowser(this.platform)) {
      return;
    }
    const unicodeEmoji = this.toUni(emojiCode);
    const fromCodePoint = twemoji.convert.fromCodePoint(unicodeEmoji);
    const emoji = twemoji.parse(fromCodePoint, {
      folder: 'svg',
      ext: '.svg'
    });
    return emoji.replace(
      'twemoji.maxcdn.com/v',
      'cdnjs.cloudflare.com/ajax/libs/twemoji',
    );
  }

}
